import { SEO } from 'components/main-page/home-page/seo/SEO'
import { useEffect, useState } from 'react'
import { useValidation } from 'hooks/useValidation'
import { SEO_VALIDATION } from 'services/validation/home-page/seoValidation'
import { useFetch } from 'services/useFetch'
import { API_SEO } from 'services/api-home-page/apiSEO'
import { Alert } from 'avo-ui'
import { convertErrorMessage } from 'utils/utils'

const INITIAL_STATE = {
    title: null,
    description: null,
}

const FIELD_NAME_DETAIL = {
    title: 'Meta title',
    description: 'Meta description',
}

export const SEOContainer = () => {
    const [SEODetail, setSEODetail] = useState(INITIAL_STATE)
    const { fetching: getSEODetail, isLoading } = useFetch(API_SEO.DETAIL)
    const { fetching: updateSEO, isLoading: isUpdating } = useFetch(API_SEO.UPDATE)
    const [errorMessage, setErrorMessage] = useState({})
    const { validateForm, errorForm } = useValidation({
        form: SEODetail,
        schema: SEO_VALIDATION,
    })

    const onChangeForm = (e) => {
        const { name, value } = e
        setSEODetail({ ...SEODetail, [name]: value })
    }

    const onSubmit = () => {
        setErrorMessage({})
        validateForm().then(() => {
            updateSEO(SEODetail)
                .then(() => {
                    return Alert({
                        icon: 'success',
                        title: 'Success',
                        message: 'SEO Updated !',
                    })
                })
                .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
        })
    }

    useEffect(() => {
        getSEODetail().then((response) => setSEODetail({ ...response?.data }))
    }, [])

    const props = {
        SEODetail,
        errorForm: { ...errorForm, ...errorMessage },
        onChangeForm,
        isLoading,
        isUpdating,
        onSubmit,
    }

    return <SEO {...props} />
}
